export default "__VITE_ASSET__BaBGY59l__"